export class ContraSenha {    
    nivel: string
    seed: string
    senha: string
    contra_senha: string
}